<template>
  <div class="field-wrapper p-4">
    <h2 v-if="title" id="form-title">{{title}}</h2>
    <label :for="id" class="text-sm px-2">{{ label }}</label>
    <textarea :disabled='disabled' v-if="type === 'textarea'" :name="name" :id="id" v-model="inputVal"></textarea>
    <input v-else :disabled='disabled' :type="type || 'text'" :name="name" :id="id" v-model="inputVal" />
    <span v-if="error" class="error">{{error}}</span>

  </div>
</template>

<script>
    export default {
      props: ['name', 'id', 'label', 'type', 'value', 'disabled', 'title', 'error'],
      computed: {
        inputVal: {
          get () {
            return this.value
          },
          set (val) {
            this.$emit('input', val)
          }
        }
      }
    }

</script>

<style lang="scss" scoped>
  .field-wrapper {
    display: block;
    overflow: hidden;
    label {
      display: block;
      text-align: left;
      font-weight: 600;
      text-transform: uppercase;
    }
    #form-title {
      margin-top: 0;
      font-weight: 400;
      text-align: center;
      color: #88ad3f;
      margin-bottom: 20px;
    }
  }

  .error {
    color: red;
  }
</style>
